<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[
        { type: 'date', label: '점검일'},
      ]" />

<!--    근로자 및 산업재해 현황-->
    <div>
      <h5 class="my-4"><i class="dot"></i> 학교(기관) 현황</h5>
      <span style="font-weight: 700;">현업근로자 수</span>
      <div class="writeGridContainer">
        <div>
          <div>조리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>시설관리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_2" />
        </div>
        <div>
          <div>청소</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>
        <div>
          <div>통학차량보조</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_4" />
        </div>
        <div>
          <div>기타</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_5" />
        </div>
      </div>

      <span style="font-weight: 700;">도급종사자</span>
      <div class="writeGridContainer">
        <div>
          <div>조리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>시설관리</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>
        <div>
          <div>청소</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div>
          <div>통학차량보조</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
        <div>
          <div>기타</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" />
        </div>
      </div>
    </div>


    <!-- 점검표 -->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="점검표"
      :table-header-title="'점검사항'"
      :table-header-check="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '점검결과(미흡 시 사유 기재)' }, {text: '증빙자료'}]"
      contentBefore="•"
      v-model="form.inspectList"
      class="mt-5"
    >
      <template #customType="{ trData, id, input, noteIndex }">
        <div v-if="trData">
          <div
            v-if="trData.customTypes.length <= noteIndex ?
      (trData.customTypes[0] !== 4 && trData.customTypes[0] !== 5)
      : (trData.customTypes[noteIndex] !== 4 && trData.customTypes[noteIndex] !== 5)"
            class="p-2">

            <div v-for="(field, index) in fieldsByType(trData.customTypes.length <= noteIndex ? trData.customTypes[0] : trData.customTypes[noteIndex])"
                 :key="index" class="flex justify-between items-center mt-1">
              <span>{{ field.label }}</span>
              <p v-if="isPrint" class="print-input flex-1">{{ trData[field.inputKey] }}</p>
              <template v-else>
                <component :is="field.inputComponent" v-model="trData[`${field.inputKey}_${noteIndex}`]" :readonly="board.readonly" :style="field.style"/>
              </template>
            </div>
          </div>
          <div v-else class="p-2">
            <div class="flex justify-between items-center mt-1">
              <p v-if="isPrint" class="print-input flex-1">{{ trData.input1 }}</p>
              <template v-else>
                <ml-input :readonly="board.readonly" v-model="trData[`input1_${noteIndex}`]" v-if="trData.customTypes[0] === 4"/>
                <ml-textarea :readonly="board.readonly" v-model="trData[`input1_${noteIndex}`]" v-else rows="3" style="width: calc(50% - 4px);" />
              </template>
              <p v-if="isPrint" class="print-input flex-1 ml-1">{{ trData.input2.fileName }}</p>
              <file-uploader :readonly="board.readonly" v-else v-model="trData[`input2_${noteIndex}`]" class="ml-1" placeholder="파일업로드" :style="{ width: 'calc(50% - 4px)' }"/>
            </div>
          </div>
        </div>
      </template>
    </table-inspect-merge>

    <!-- 확인자 -->
    <div v-if="!isPrint" class="mt-28px">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>작성자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>검토자</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>회람자</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>승인자</div>
          <ml-input v-if="!isPrint" v-model="form.sign4.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign4.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign4.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign4.sign" :src="form.sign4.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import * as inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploader from "@/components/FileUploader.vue";
import Print from "@/views/boards/single-page/670/Print.vue";

export default {
  components: {
    Print,
    FileUploader,
    TableCustom,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",

        inspectList: inspectData.inspectTable,

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    fieldsByType(type) {
      switch (type) {
        case 1:
        case 3:
          return [
            { label: '실시일', inputKey: 'input1', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            { label: '실시일', inputKey: 'input2', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            ...(type === 3 ? [{ label: '개선사항', inputKey: 'input3', inputComponent: 'ml-input' }] : []),
            // Add more fields as needed
          ];
        case 2:
          return [
            { label: '교육대상', inputKey: 'input1', inputComponent: 'ml-input' },
            { label: '실시인원', inputKey: 'input2', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        case 6:
          return [
            { label: '미실시 인원', inputKey: 'input1', inputComponent: 'ml-input' },
            { label: '실시인원', inputKey: 'input2', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        case 7:
          return [
            { label: '실시일', inputKey: 'input1', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            { label: '개선사항', inputKey: 'input2', inputComponent: 'ml-input' },
            { label: '조치사항', inputKey: 'input3', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        default:
          return [];
      }
    }
  },
};
</script>

<style scoped lang="scss"></style>
